import {Controller} from "@hotwired/stimulus"
import moment from 'moment'
const csrfToken = document.getElementsByName("csrf-token")[0].content;

export default class PurchaseAdController extends Controller {
    static targets = ["advIndex", "purchaseAdId", "slots", "adTime", "purchaseAdIndex", "select", "advHourTimeIndex", "timeIndex"]

    connect() {
        this.filterForm = JSON.parse($(this.element).attr('data-ad-params'))
        this.rangeFilterValue = {
            fans: null,
            age: null,
            pricerange: null
        }
        let range_type = ['fans', 'age', 'price']
        for (const type of range_type ) {
            const checkbox = document.querySelector(`input[type="checkbox"][data-action*="${type}Range"]`)
            if (checkbox) {
                this.updateRangeSlider(type, checkbox)
            }
        }
        this.checkboxes = this.element.querySelectorAll('input[type="checkbox"]')


        if (this.hasAdvIndexTarget) {
            this.findOrCreateAd(this.getIndex())
        }

        if (this.hasAdvHourTimeIndexTarget) {
            let obj = this.findOrCreateAd(this.getIndex())
            obj['confirm_user'] = false
            this.setHourTimeSlot(obj)
        }
        if(($(this.element).attr('data-ad-params')) != null){
            this.filterForm = JSON.parse($(this.element).attr('data-ad-params'))
        }
        if (this.hasPurchaseAdIdTarget) {
            this.findOrCreateAd(this.purchaseAdIdTarget.value)
        }
        if (this.hasPurchaseAdIndexTarget) {
            if(this.filterForm == {} || jQuery.isEmptyObject(this.filterForm))
                this.filterForm[$(this.purchaseAdIndexTarget).attr('data-purchase-ad-index-param')] = {}
        }
        if (this.hasSelectTarget) {
            $(this.selectTarget).on('select2:unselect', function () {
                let event = new Event('change', {bubbles: true})
                this.dispatchEvent(event);
            })
            $(this.selectTarget).on('select2:select', function () {
                let event = new Event('change', {bubbles: true})
                this.dispatchEvent(event);
            });
        }
    }


    fansRange(e){
        this.updateRangeSlider('fans', e.target)
        this.setupFilterFormData('fans', e)
    }

    ageRange(e){
        this.updateRangeSlider('age', e.target)
        this.setupFilterFormData('age', e)
    }

    priceRange(e){
        this.updateRangeSlider('price', e.target)
        this.setupFilterFormData('price', e)
    }

    updateRangeSlider(type, e){
        let instance = $('#purchase_order_form').find('input[data-filter-type="'+type+'"]').data("ionRangeSlider");
        instance?.update({
            disable: !e.checked
        })
    }

    setupFilterFormData(type, e){
        if(e.target.checked){
            this.filterForm[type] = this.rangeFilterValue[type]
        }else{
            delete this.filterForm[type]
        }
    }

    selectGender(e) {
        const checkboxes = document.querySelectorAll('#gender-group input[type="checkbox"]');
        const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
        const errorBox = document.getElementById('gender-error');

        if (isChecked) {
            errorBox.style.display = 'none';
        } else {
            errorBox.style.display = 'block';
        }
    }

    //================ step2 ====================

    openCalander(e){
        e.preventDefault()
        let obj =$(e.target)
        let modal = new bootstrap.Modal('#calenderModal', {backdrop: false})
        let html = '<div class="modal-header">\n' +
            '    <button type="button" class="btn close float-end" data-bs-dismiss="modal" aria-label="Close">\n' +
            '      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '        <path d="M4 20L20 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
            '        <path d="M20 20L4 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
            '      </svg>\n' +
            '    </button>\n' +
            '  </div>\n' +
            '  <div class="modal-body" data-controller="full-calendar">' +
            '<div data-full-calendar-target="monthView" data-start-date="'+obj.attr('data-start-date')+'" data-end-date="'+obj.attr('data-end-date')+'"></div>'
        $('#calenderModal .modal-content').html('<turbo-frame id="calender_view">'+html+'</turbo-frame>')
        modal.show()
    }

    selectDate(e) {
        this.setSelectedDate(e.target.value)
    }

    setSelectedDate(date){
        this.date = date
        $('.selected-date-' + this.getIndex()).html(moment(date).format("MMMM DD, YYYY"))
        $('.hour-slot').attr('style', '')
        $('.time-slot').css('display', 'none')
        this.setHours(this.getDateHash(this.getSlotsHash()))

        let obj = $(this.advIndexTarget)
        if(obj.find('#select_date_'+moment(date).format("YYYY-MM-DD")).length == 0){
            obj.find('#select_date_' + moment(date).format("YYYY-MM-DD")).prop('checked', true)
            obj.find('.select-dates').prop('checked', false)
            obj.find('.open-calender').removeClass('active')
        }else{
            obj.find('.select-dates').prop('checked', false)
            obj.find('#select_date_'+moment(date).format("YYYY-MM-DD")).prop('checked', true)
            obj.find('.open-calender').addClass('active')
        }


    }

    selectHour(e) {
        this.hour = e.params['hour']
        let filtered = this.getHourHash(this.getSlotsHash())

        $(".ad-time" + this.getIndex()).html(moment(this.hour, 'H').format("hh:mm A"))

        $('.hour-slot,.time-slot').toggle(500);
        this.setTimes(filtered)
        this.setHours(filtered)
    }

    showHour(e) {
        this.setHours(this.getDateHash(this.getSlotsHash()))
        $('.hour-slot,.time-slot').toggle(500);
    }

    showHourTime(e) {
        $('.hour-time-slots,.ad-year-calender').toggle(500);
    }

    setHours(obj) {
        $('.slot_available_hr_time[fill="#FF6E01"]').attr('fill', '#BDD848')
        let hours = this.getHourArray(obj)

        $('.slot_available_hr_time').filter(function () {
                return ($.inArray(Number.parseInt($(this).attr('id').split("_").at(-1)), hours) !== -1)
            }
        ).attr('fill', '#FF6E01');
        this.setHourSlotCount()
    }

    setHourSlotCount(){
        let data = this.getBookedSlots()[this.date]

        $('.slot-counter-list .item').html(360)
        if(data != undefined) {
            for (const key of Object.keys(data)) {
                let value = Number.parseInt($('#' + this.getIndex() + '_slot_hr_' + key).html())
                $('#' + this.getIndex() + '_slot_hr_' + key).html(value - data[key].length)
            }
        }
        let filtered = this.getDateHash(this.getSlotsHash())
        let hours = this.getHourArray(filtered)
        if(hours!=undefined) {
            for (const key of $.unique(hours)) {
                let filtered_array = filterObject(filtered, "ad_hour", key);
                let value = Number.parseInt($('#' + this.getIndex() + '_slot_hr_' + key).html())
                $('#' + this.getIndex() + '_slot_hr_' + key).html(value - Object.keys(filtered_array).length)
            }
        }
    }

    setTimes(obj) {
        let times = this.getTimeArray(obj)
        $('.slot_available_time').attr('fill', '#BDD848').attr('data-action', 'click->purchase-ad#selectTime')
        $('.slot_available_time').filter(function () {
                return ($.inArray($(this).attr('id').split("_").at(-1), times) !== -1)
            }
        ).attr('fill', '#FF6E01');

        let date = this.date
        let hour = this.hour
        $('.slot_available_time').each(function (index, e) {
            let d = new Date(date + " " + hour + ":00");
            let value = $(e).attr('id').split("_").at(-1)
            d.setTime(d.getTime() + (value * 10 * 1000))
            let time = " - " + d.toLocaleTimeString()
            d.setTime(d.getTime() - (10 * 1000))
            time = d.toLocaleTimeString() + time
            $(e).attr('data-bs-original-title', time)
        })

        let data = this.getBookedSlotsArray();
        if(data != undefined){
            for (const key of data) {
                $('#'+this.getIndex()+'slot_available_'+key).attr('data-action', '').attr('fill', '#494254');
            }
        }
    }

    getBookedSlots(){
        let booked_time = this.findOrCreateAd(this.getIndex())
        return booked_time['booked_slots'] || {}
    }

    getBookedSlotsArray() {
        const data = this.getBookedSlots();
        return data?.[this.date]?.[this.hour] ?? [];
    }

    selectTime(e) {
        const obj = this.findOrCreateAd(this.getIndex());
        obj["confirm_user"] = false;

        let value = this.getClickedValue(e);
        const slots = this.getSlotsHash();

        const filtered = this.getHourHash(slots);
        const timeArray = this.getTimeArray(filtered);

        // If clicked time already selected -> remove
        if (this.isSelectedTime(filtered, timeArray, value)) {
            this.removeSelectedTimeOnClick(slots, filtered, value);
            this.afterSelect(slots);
            return;
        }

        const selectList = this.buildSelectList(value);
        const booked = this.getBookedSlotsArray();

        // If booked overlaps -> stop
        if (this.hasBookedOverlap(booked, selectList)) {
            alert("You can not select this slots");
            this.afterSelect(slots);
            return;
        }

        // If max slots reached -> stop
        if (Object.keys(slots).length >= this.totalSlots) {
            alert(`You can select only ${this.totalSlots} Slots`);
            this.afterSelect(slots);
            return;
        }

        // If range overlaps existing selections -> remove existing group first (same behavior as your code)
        this.removeOverlappingExistingSelectionIfAny(slots, filtered, timeArray, selectList);

        // Add slots for N seconds
        const ok = this.addSlotsForSeconds(value, e);
        if (!ok) return false;

        this.group = this.group + 1;
        this.afterSelect(this.getSlotsHash());
    }

    getClickedValue(e) {
        return $(e.target).attr("id").split("_").at(-1);
    }

    isSelectedTime(filtered, timeArray, value) {
        return !jQuery.isEmptyObject(filtered) && timeArray.includes(value);
    }

    removeSelectedTimeOnClick(slots, filtered, value) {
        const time = filterObject(filtered, "ad_slot", value);
        const key = Object.keys(time)[0];
        this.removeTime(slots, filtered[key]["group_no"]);
    }

    buildSelectList(value) {
        const start = Number.parseInt(value);
        const seconds = Number.parseInt(this.seconds);
        return Array.from({ length: seconds }, (_, i) => i + start);
    }

    hasBookedOverlap(bookedData, selectList) {
        if (!bookedData) return false;
        return bookedData.some((el) => selectList.includes(Number.parseInt(el)));
    }

    removeOverlappingExistingSelectionIfAny(slots, filtered, timeArray, selectList) {
        const existArray = timeArray.filter((el) =>
          selectList.includes(Number.parseInt(el))
        );

        if (existArray.length === 0) return;

        const time = filterObject(filtered, "ad_slot", existArray[0]);
        const key = Object.keys(time)[0];
        this.removeTime(slots, filtered[key]["group_no"]);
    }

// returns true if it added everything, false if it had to stop (next day + return false)
    addSlotsForSeconds(value, e) {
        const seconds = Number.parseInt(this.seconds);

        for (let i = 0; i <= seconds - 1; i++) {
            const slots = this.getSlotsHash();
            const time = this.getTimeArray(this.getDateHash(slots));

            if (time.length >= this.repet) {
                this.setSelectedDate(moment(this.date).add(1, "d").format("YYYY-MM-DD"));
                return false;
            }

            getTime(
              value,
              this.date,
              this.hour,
              $(this.advIndexTarget),
              this.group,
              slots,
              e.currentTarget.parentNode
            );

            value = String(Number.parseInt(value) + 1);
        }

        return true;
    }

    afterSelect(slots) {
        $(".continue-slot").prop("disabled", jQuery.isEmptyObject(slots));
        this.updateSelectedSlotsCount(slots);
    }





    // updateSelectedSlotsCount(slots) {
    //     const count = Object.keys(slots).length;
    //     const countSpan = $('#selected-slots-count');
    //     countSpan.text(count > 0 ? `(${count})` : '');
    // }

    canSelectTime(value, slots, timeArray, e) {
        let selectList = Array.from({length: Number.parseInt(this.seconds)}, (_, i) => i + Number.parseInt(value))
        let data = this.getBookedSlotsArray()

        if (data == undefined || data.filter(element => selectList.includes(Number.parseInt(element))).length == 0) {

            if (Object.keys(slots).length < this.totalSlots) {

                let existArray = timeArray.filter(element => selectList.includes(Number.parseInt(element)))
                if (existArray.length != 0) {
                    let time = filterObject(filtered, "ad_slot", existArray[0]);
                    this.removeTime(slots, filtered[Object.keys(time)[0]]['group_no'])
                }

                for (let i = 0; i <= Number.parseInt(this.seconds) - 1; i++) {
                    let slots = this.getSlotsHash()
                    let time = this.getTimeArray(this.getDateHash(slots))

                    if (time.length < this.repet) {
                        getTime(value, this.date, this.hour, $(this.advIndexTarget), this.group, slots, e.currentTarget.parentNode)
                    } else {
                        this.setSelectedDate(moment(this.date).add(1, 'd').format("YYYY-MM-DD"))
                        return true;
                    }
                    value = String(Number.parseInt(value) + 1)
                }
                this.group = this.group + 1
                return true;
            } else {
                alert("You can select only " + this.totalSlots + " Slots")
            }
        } else {
            alert("You can not select this slots", 'warning')
        }
    }

    handleSlotSelection(value, slots, filtered, timeArray) {
        const selectList = new Set( Array.from({length: Number.parseInt(this.seconds)}, (_, i) => i + Number.parseInt(value)) );
        let existArray = timeArray.filter(element => selectList.includes(Number.parseInt(element)))
        if(existArray.length != 0){
            let time = filterObject(filtered, "ad_slot", existArray[0]);
            this.removeTime(slots, filtered[Object.keys(time)[0]]['group_no'])
        }

        for (let i = 0; i <= Number.parseInt(this.seconds) - 1; i++) {
            if (!this.tryAddSlot(value)) return
            value = String(Number.parseInt(value) + 1)
        }

        this.group = this.group + 1
    }

    tryAddSlot(value) {
        let slots = this.getSlotsHash()
        $("#" + this.getIndex() + "slot_available_" + value).attr('fill', '#FF6E01')
        let time = this.getTimeArray(this.getDateHash(slots))

        if (time.length >= this.repet) {
            this.setSelectedDate(moment(this.date).add(1, 'd').format("YYYY-MM-DD"))
            return false
        }

        getTime(value, this.date, this.hour, $(this.advIndexTarget), this.group, slots)
        return true
    }

    removeSelectedTime(e){
        e.preventDefault()
        let group_no = $(e.currentTarget).attr('data-group')
        let slots = this.getSlotsHash()
        this.removeTime(slots, group_no)
        this.updateSelectedSlotsCount(slots);
    }

    updateSelectedSlotsCount(slots) {
        const count = Object.keys(slots).length;
        const countSpan = $('#selected-slots-count');
        countSpan.text(count > 0 ? `(${count})` : '');
    }

    removeTime(slots, group_no){
        let groups = filterObject(slots, "group_no", Number.parseInt(group_no));
        $.each(Object.keys(groups), function (k, key) {
            $("#" + this.getIndex() + "slot_available_" + slots[key]['ad_slot']).attr('fill', '#BDD848')
            delete slots[key]
        }.bind(this))
        $(this.advIndexTarget).find('.selected-times .time_'+group_no).remove()
        this.setHourSlotCount()
    }

    changeTime({ params: { btnType } }){
        let i = this.getIndex(),
            date = (btnType == 'plus') ? moment(this.hour, 'H').add(1, 'hours') : moment(this.hour, 'H').subtract(1, 'hours');
        $(".ad-time" + i).html(moment(date).format("hh:mm A"))
        this.hour = Number.parseInt(moment(date).format("H"))
        this.setTimes(this.getHourHash(this.getSlotsHash()))
    }

    //================ step2 ====================


    setHourTimeSlot(obj){
        obj['purchase_bs_slots_attributes'] = this.getSlotsHash()
        let dataSet = this.advHourTimeIndexTarget.dataset
        this.hour = 0
        this.repet = Number.parseInt(dataSet.seconds) * Number.parseInt(dataSet.repet)
        this.date = dataSet.startDate
        let date1 = moment(this.date);
        let date2 = moment(dataSet.endDate);
        let days = date2.diff(date1, 'days')
        $('.selected-date-' + this.getIndex()).html(moment(this.date).format("MMMM DD, YYYY"))
        this.seconds = dataSet.seconds
        this.totalSlots = this.repet * (days + 1)
        this.group = Number.parseInt(dataSet.group)
        this.setHours(this.getDateHash(obj['purchase_bs_slots_attributes']))
    }

    getIndex() {
        return $(this.advIndexTarget).attr('data-purchase-ad-index')
    }

    findOrCreateAd(id) {
        return this.filterForm[id] || (this.filterForm[id] = {})
    }

    getDateHash(obj) {
        return filterObject(obj, "ad_date", this.date);
    }

    getHourHash(obj) {
        let filtered_array = this.getDateHash(obj);
        return filterObject(filtered_array, "ad_hour", this.hour);
    }

    getSlotsHash() {
        let ad = this.findOrCreateAd(this.getIndex())
        return ad['purchase_bs_slots_attributes'] || {}
    }

    getHourArray(obj) {
        return Object.keys(obj).map(e => obj[e]['ad_hour'])
    }

    getTimeArray(obj) {
        return Object.keys(obj).map(e => obj[e]['ad_slot'])
    }

    changeDate({ params: { btnType } }) {
        const selected = $(".select-dates:checked");

        if (!selected.length) return;

        const currentDate = moment(selected.val(), "YYYY-MM-DD");

        const allDates = $(".select-dates")
            .map(function () {
            return $(this).val();
            })
            .get()
            .sort();

        const minDate = moment(allDates[0], "YYYY-MM-DD");
        const maxDate = moment(allDates.at(-1), "YYYY-MM-DD");

        let nextDate =
            btnType === "plus"
            ? currentDate.clone().add(1, "days")
            : currentDate.clone().subtract(1, "days");

        if (nextDate.isBefore(minDate) || nextDate.isAfter(maxDate)) return;

        const nextEl = $(`.select-dates[value='${nextDate.format("YYYY-MM-DD")}']`);

        if (nextEl.length) {
            nextEl.click();
            this.updateButtons(nextDate, minDate, maxDate);
        }
    }

    updateButtons(current, minDate, maxDate) {
        const minusBtn = this.element.querySelector("[data-purchase-ad-btn-type-param='minus']");
        const plusBtn  = this.element.querySelector("[data-purchase-ad-btn-type-param='plus']");

        if (!minusBtn || !plusBtn) return;

        minusBtn.disabled = current.isSame(minDate, "day");
        plusBtn.disabled  = current.isSame(maxDate, "day");

        minusBtn.classList.toggle("disabled", minusBtn.disabled);
        plusBtn.classList.toggle("disabled", plusBtn.disabled);
    }

    async callFilterAjax(index) {
        let data = this.filterForm[index]
        if (data != undefined) {
            data['index'] = index
            if ($("#purchase_order_purchase_ads_attributes_" + index + "_id").val() != undefined) {
                data['purchase_ad_id'] = $("#purchase_order_purchase_ads_attributes_" + index + "_id").val()
            }
            await fetch("/users/purchase_orders/social_users", {
                method: 'post',
                headers: {
                    Accept: "text/vnd.turbo-stream.html",
                    "X-CSRF-Token": csrfToken,
                    'Content-type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams(data).toString()
            })
                .then(r => r.text(
                ))
                .then((html) => {
                    Turbo.renderStreamMessage(html)
                })
            setTimeout(() => {
                let container = $('.purchase-ad-item-' + index)
                if (container.find('.backskin-needed').val() != '') {
                    $('.purchase-ad-item-' + index + ' .adv-user-list-checkbox input[type="checkbox"]').prop('checked', false)
                    $('.purchase-ad-item-' + index + ' .adv-user-list-checkbox input[type="checkbox"]:lt(' + container.find('.backskin-needed').val() + ')').prop('checked', true)
                    updateUserMessage($('.purchase-ad-item-' + index), container.find('.backskin-needed').val())
                }
            }, 250);
        }

    }

    nextStepClick(e) {
        e.preventDefault()
        let obj = this.findOrCreateAd(this.getIndex())
        if (!jQuery.isEmptyObject(this.filterForm)) {
            let slots = this.getSlotsHash()
            const selectedSlotCount = Object.keys(slots).length;
            if (selectedSlotCount < this.totalSlots) {
                alert(`Please select all ${this.totalSlots} required slots before continuing.`)
                return;
            }

            if (obj['confirm_user'] || this.element.dataset?.selectUser !== 'true' ) {
                $(e.target).prop('disabled', true).html("<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n" +
                    "  <span>Loading...</span>");
                globalThis.location.pathname = `/backskin_ads/${this.getIndex()}/select_media`
              return;
            }
            if ($(this.element).valid()) {
                obj['index'] = this.getIndex()
                $(e.target).prop('disabled', true).html("<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n" +
                    "  <span>Loading...</span>");

                let params = {
                    method: 'post',
                    headers: {
                        "X-CSRF-Token": csrfToken,
                        Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
                        'Content-Type': 'application/json'
                    }
                }
                params['body'] = JSON.stringify({
                    purchase_backskin: this.filterForm,
                    filter: obj['filter'], index: this.getIndex()
                })


                fetch(`/backskin_ads/${this.getIndex()}/select_users`, params).then(r => {
                    $(e.target).prop('disabled', false).html("Continue")
                    if (r.ok && !r.redirected) {
                        return r.text()
                    } else {
                        if (r.redirected) {
                            globalThis.location.href = r.url
                            return ''
                        }
                        return r.text()
                    }
                })
                    .then(response => {
                        Turbo.renderStreamMessage(response)
                        let modal = bootstrap.Modal.getOrCreateInstance('#shareRecipeModal')
                        document.querySelectorAll('.modal-body').forEach(el => {
                            el.classList.add('p-0');
                        });
                        modal.show()
                    })

            }
        }
    }

}

function updateUserMessage(container, value) {
    if (value > Number.parseInt(container.find('.user-count').html())) {
        container.find('.user-count').addClass('text-danger')
        container.find('.selected-user-warning').removeClass('d-none')
        container.find('.selected-user-warning').find('.selected-backskins').html(value)
        container.find('.confirm-user').attr("disabled", "disabled").css({'pointer-events': 'none'}).addClass('d-none');
    } else {
        container.find('.selected-user-warning').addClass('d-none')
        container.find('.user-count').removeClass('text-danger').addClass('text-success')
        container.find('.confirm-user').removeAttr("disabled").css({'pointer-events': 'visible'});
        $('.adv-user-list-checkbox').find('input[type="checkbox"]').attr('checked', false)
        $('.adv-user-list-checkbox input[type="checkbox"]:lt(' + value + ')').attr('checked', true)
    }
    updateUserList(container)
}

function updateUserList(container) {
    container.find('.adv-user-list-checkbox').each(function () {
        let divObj = $(this)
        if (divObj.find('input[type="checkbox"]')[0].checked) {
            (divObj.find("#id").val() == undefined) ? divObj.find('input[type="hidden"]').removeAttr('disabled') : divObj.find('#delete').val(false)
        } else {
            (divObj.find("#id").val() == undefined) ? divObj.find('input[type="hidden"]').attr('disabled', true) : divObj.find('#delete').val(true)
        }
    });
}

const filterObject = (obj, filter, filterValue) =>
    Object.keys(obj).reduce((acc, val) =>
        (obj[val][filter] === filterValue ? {
                ...acc,
                [val]: obj[val]
            } : acc
        ), {});

function getTime(value, date, hour, indexObj, group, slots, parentNode) {
    let startDate = parentNode?.dataset.startDate
    let startTime = parentNode?.dataset.startTime
    let endDate = parentNode?.dataset.endDate
    let endTime = parentNode?.dataset.endTime
    let startDateTime = new Date(startDate + " " + startTime);
    let endDateTime = new Date(endDate + " " + endTime);
    let d = new Date(date + " " + hour + ":00");
    d.setTime(d.getTime() + (value * 10 * 1000))
    let time = " - " + d.toLocaleTimeString()
    let now = new Date();
    if (d < now) {
        alert('Please select a future time.');
        return false;
    }

    if (date === endDate) {
        if (endDateTime < d) {
            alert(`Please select slot before ${endDateTime.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            }).toUpperCase()}`);
            return false;
        }
    }
    d.setTime(d.getTime() - (10 * 1000))
    time = d.toLocaleTimeString() + time
    if (date === startDate) {
        if (startDateTime > d) {
            alert(`Please select slot after ${startDateTime.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            }).toUpperCase()}`);
            return false;
        }
    }
    const maxKeyNum = Object.keys(slots).length == 0 ? -1 : Math.max(...(Object.keys(slots)).map(Number));
    slots[maxKeyNum + 1] = {
        ad_date: date,
        ad_hour: hour,
        ad_slot: value,
        group_no: group,
        ad_time: time
    }
    $("#" + indexObj.attr('data-purchase-ad-index') + "slot_available_" + value).attr('fill', '#FF6E01')
    timeHtmlContent(indexObj, group, time)
}

function timeHtmlContent(indexObj, group, time, slots) {
    let obj = indexObj.find('.selected-times');
    let slotsValue = JSON.stringify(slots);
    let slots_input = indexObj.find('input[name="slots[]"]');

    if (slots_input.length === 0) {
        obj.append(`<input type="hidden" name="slots[]" value='${slotsValue}'>`);
    } else {
        slots_input.val(slotsValue);
    }
    obj.append(
      `<li class="d-flex align-items-center justify-content-center gap-2 mb-2 time_${group}">
            <a href="#" data-action="purchase-ad#removeSelectedTime" data-group="${group}">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 16.6067L13.3958 10.0012L19.9976 3.39695L16.6042 0L9.9988 6.60425L3.39455 0L0 3.39695L6.60185 10.0012L0 16.6055L3.39695 20L9.9988 13.3958L16.6006 20L20 16.6067Z" fill="#FF0303"/>
                </svg>
            </a>
            <div class="position-relative h-100 w-100 select-slot-time bg-center bg-100 bg-no-repeat">
                <h6 class="text-black lh-1 mb-0 z-1 fs-18 position-absolute top-50 start-50 translate-middle w-100 px-2 text-center">${time}</h6>
            </div>
        </li>`
    );
}